import { CLOSE_ALL_MODALS_FULFILLED, SET_ACTIVE_MODAL_FULFILLED } from '../constants/actions/modalActions';

export const closeAllModals = () => ({
	type: CLOSE_ALL_MODALS_FULFILLED,
	payload: null,
});

export const setActiveModal = (
	modal: string,
	modalHeading?: string,
	modalCallback?: string,
	modalQrCodeValue?: string, // TODO: taka út
	modalLat?: number,
	modalLng?: number,
	shipmentId?: string,
	page?: number,
	index?: number,
	flag?: boolean
) => ({
	type: SET_ACTIVE_MODAL_FULFILLED,
	payload: {
		modal,
		modalHeading,
		modalCallback,
		modalQrCodeValue,
		modalLat,
		modalLng,
		shipmentId,
		page,
		index,
		flag,
	},
});
